const baseDetail = require('base/product/detail');
const base = require('site/product/base');
const deliveryRules = require('site/deliveryrules/deliveryrules');

baseDetail.addToCart = base.addToCart;

/* instorepickup START */

/**
 * Update availability on change event on quantity selector and on store:afterRemoveStoreSelection event.
 * If store has been selected, exit function otherwise proceed to update attributes.
 * @param {Object} element DOM Element.
 */
const updateAvailability = (element) => {
    const searchPID = $(element).closest('.product-detail').attr('data-pid');
    const selectorPrefix = `.product-detail[data-pid="${searchPID}"]`;
    if ($(`${selectorPrefix} .selected-store-with-inventory`).is(':visible')) {
        return;
    }

    let $productContainer = $(element).closest('.product-detail');
    if (!$productContainer.length) {
        $productContainer = $(element).closest('.modal-content').find('.product-quickview');
    }

    if ($('.bundle-items', $productContainer).length === 0) {
        base.attributeSelect(
            $(element).find('option:selected').data('url'),
            $productContainer,
        );
    }
};

/**
 * Registering on change event on quantity selector and on store:afterRemoveStoreSelection event.
 */
baseDetail.availability = () => {
    $(document).on('change', '.quantity-select', function (e) {
        e.preventDefault();

        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.modal-content').find('.product-quickview');
        }

        if ($('.bundle-items', $productContainer).length === 0) {
            var url = $(e.currentTarget).find('option:selected').data('url');
            if (!url) {
                url = $(e.currentTarget).data('variation-url');
            }

            if (url) {
                base.attributeSelect(url, $productContainer);
            }
        }
    });

    // Add custom store removal handler
    $(document).on('store:afterRemoveStoreSelection', (e, element) => {
        e.preventDefault();
        updateAvailability(element);
    });
};
/* instorepickup END */

/**
 * Purchase option handler to display or hide content options
 */
baseDetail.purchaseOptionHandler = () => {
    $(document).off('change', 'input[name="purchase-method"]').on('change', 'input[name="purchase-method"]', (e) => {
        if ($(e.target).attr('id') !== 'freeLocalPickup' && !$('.selected-store-with-inventory').hasClass('display-none')) {
            $('#remove-store-selection').click();
        }
        const $container = $(e.target).closest('.product-detail');
        const available = $container.find('.product-available').val();
        $container.find('.add-to-cart').prop('disabled', $(e.target).attr('id') === 'freeLocalPickup' || !available || available === 'false');
    });

    $(document).off('click', '.purchase-option-container').on('click', '.purchase-option-container', (e) => {
        $(e.target).find('input[type=radio]').prop('checked', true).trigger('change');
    });

    const $selectedInput = $('input[name="purchase-method"]:checked');

    if ($selectedInput.attr('id') === 'freeLocalPickup') {
        $('.add-to-cart').prop('disabled', true);
    }

    $('.purchase-option-container').on('change', 'input[type=radio][name="purchase-method"]', (e) => {
        $(e.target).closest('.purchase-option-container').find('.purchase-option').removeClass('selected');
        $(e.target).closest('.purchase-option').addClass('selected');
    });

    const $pdpAutoshipSelectedFrequency = $('.js--autoship-frequency-selector-container a.js--selectedAutoshipFrequency');
    const $pdpAutoshipFrequency = $('.js--autoship-frequency-selector-container select.js--autoshipFrequency');
    if ($pdpAutoshipFrequency.length > 0) {
        $pdpAutoshipSelectedFrequency.text($pdpAutoshipFrequency.find('option:selected').text());
        $(document).on('change blur', '.js--autoship-frequency-selector-container select.js--autoshipFrequency', () => {
            $pdpAutoshipSelectedFrequency
                .text($pdpAutoshipFrequency.find('option:selected').text())
                .removeClass('d-none');
            $pdpAutoshipFrequency.addClass('d-none');
        });
        $pdpAutoshipSelectedFrequency.on('click', (e) => {
            e.preventDefault();
            $pdpAutoshipSelectedFrequency.addClass('d-none');
            $pdpAutoshipFrequency.removeClass('d-none').focus();
        });
    }
};

baseDetail.updateAddToCart = () => {
    $('body').on('product:updateAddToCart', (e, response) => {
        // update local add to cart (for sets)
        const disabled = (!response.product.readyToOrder || !response.product.available);
        $('button.add-to-cart', response.$productContainer).attr('disabled', disabled);
        $('.product-available', response.$productContainer).val(!disabled);

        const enable = $('.product-availability').toArray()
            .every((item) => $(item).data('available') && $(item).data('ready-to-order'));
        baseDetail.methods.updateAddToCartEnableDisableOtherElements(!enable);
    });
};

baseDetail.updateAutoshipPrice = () => {
    $(document).off('change', '.product-type-option, #delivery-autoship-options').on('change', '.product-type-option, #delivery-autoship-options', () => {
        $.spinner().start();
        const autoShipPriceURL = $('.purchase-option-container > .autoship-section').data('autoship-update-url');
        const deliveryData = deliveryRules.getDeliveryOptionsRequiredData(autoShipPriceURL, '?');
        const isAutoship = $('.product-type-option').length > 0 && $('.product-type-option:checked').hasClass('autoship-option');

        fetch(`${autoShipPriceURL}${deliveryData}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.productPrices) {
                    $('.autoship-check-label__price > .original-price').text(data.productPrices.original);
                    $('.autoship-check-label__price > .autoship-price').text(data.productPrices.autoship);
                    $('.prices-add-to-cart-actions .price .sales .value').text(isAutoship ? data.productPrices.autoship : data.productPrices.original);
                }

                // Update delivery options if available
                if (data.deliveryOptions) {
                    $('body').trigger('delivery:updated', data.deliveryOptions);
                }

                $.spinner().stop();
            })
            .catch(() => $.spinner().stop());
    });
};

baseDetail.allowQuantityNumbers = () => {
    $('.quantity-select').on('keydown', (e) => {
        const invalidChars = ['-', '+', 'e', 'E', '.'];
        if (invalidChars.includes(e.key)) {
            e.preventDefault();
        }
        return true;
    });
};

baseDetail.afterAtributeSelect = () => {
    $('body').on('product:afterAttributeSelect', (e, response) => {
        const isAutoshipPrice = $('.product-type-option').length > 0 ? $('.product-type-option:checked').hasClass('autoship-option') : false;

        if (isAutoshipPrice && response.data && response.data.product
            && response.data.product.autoshipPrice) {
            $('.price', response.container).replaceWith(response.data.product.renderedAutoshipPrice);
        }

        if (response.data && response.data.product) {
            $('.autoship-section .original-price').text(response.data.product.price.sales.formatted);
            $('.autoship-section .autoship-price').text(response.data.product.autoshipPrice.sales.formatted);
        }
    });
};

baseDetail.openReviewBeforeScroll = () => {
    $(document).on('pointerup', '#yotpo-bottomline-top-div', () => {
        if (!$('.reviews.collapsible-xs').hasClass('active')) {
            $('.reviews button.title').trigger('click');
        }
    });
};

module.exports = baseDetail;
